import { useMemo, useState, useEffect } from 'react';
import moment from 'moment';

// 图例选择过滤数据
export default function useLegendList(props: {
  loading: boolean;
  legendSelected: LegendSelectedTypes;
  dataList: CommonCalendarDataTypes;
  dateType: ScheduledateTypes;
  filterFn: (itemList: any, legendSelected: boolean[]) => boolean;
}) {
  const { loading, legendSelected, dataList, dateType, filterFn } = props;

  const [legendChange, setLegendChange] = useState<number>(0);

  // 添加唯一id及如果有当前时间点数据时，把当前时间点的未来数据放前面
  const newDataList: CommonCalendarDataTypes = useMemo(() => {
    if (!Array.isArray(dataList) || !dataList) return null;
    const orgResult: CommonCalendarDataTypes = [];
    const currentTimeStart = moment().startOf(dateType).format('YYYY-MM-DD');
    const currentTimeEnd = moment().endOf(dateType).format('YYYY-MM-DD');
    for (let i = 0; i < dataList?.length; i++) {
      const t = dataList?.[i];
      const isCurrentTime = moment(t?.date || '').isBetween(currentTimeStart, currentTimeEnd, null, '[]');
      let newList = t?.list;
      // 把当前时间点的未来数据放前面
      if (isCurrentTime && Array.isArray(newList)) {
        const currentTimeBeforeList = [];
        const currentTimeAfterList = [];
        for (let j = 0; j < newList?.length; j++) {
          const k = newList?.[j];
          k?.isExpire ? currentTimeBeforeList.push(k) : currentTimeAfterList.push(k);
        }
        newList = [...currentTimeAfterList, ...currentTimeBeforeList];
      }
      orgResult?.push({
        ...t,
        list: !newList || newList?.length === 0 ? null : newList,
      });
    }
    return orgResult;
  }, [dataList, dateType]);

  const legendList: CommonCalendarDataTypes = useMemo(() => {
    if (loading || legendSelected?.every((t: boolean) => !t)) return null;
    if (!Array.isArray(newDataList) || !newDataList) return null;
    // 如果list全是null
    if (
      newDataList?.every(
        (t: { date: string; list: CommonCalendarCardDataTypes | null; [keyName: string]: any }) => !t?.list,
      )
    )
      return null;
    // if (legendSelected?.every((t: boolean) => t)) return newDataList;
    // 正常过滤数据
    const filterList: CommonCalendarDataTypes = [];
    for (let i = 0; i < newDataList?.length; i++) {
      const t = newDataList?.[i];
      const filterCardList: CommonCalendarCardDataTypes =
        t?.list?.filter((t: CommonCalendarCardItemTypes) =>
          typeof filterFn === 'function' ? filterFn?.(t, legendSelected) : true,
        ) || [];
      filterList?.push({
        ...t,
        list: !filterCardList || filterCardList?.length === 0 ? null : filterCardList,
      });
    }
    // 过滤后如果list全是null
    if (
      filterList?.every(
        (t: { date: string; list: CommonCalendarCardDataTypes | null; [keyName: string]: any }) => !t?.list,
      )
    )
      return null;

    return filterList;
  }, [loading, legendSelected, newDataList]);

  useEffect(() => {
    if (loading) return;
    setLegendChange(Date.now());
  }, [legendSelected]);

  return { legendChange, legendList };
}
